import { gql } from '@apollo/client'

export const GET_SIMILAR_PLAYERS = gql`
  query GetSimilarPlayers($input: getSimilarPlayersInput) {
    getSimilarPlayers(input: $input) {
      _id
      sFullName
      oSeo {
        sSlug
      }
      sBowlingStyle
      oTeam {
        oImg {
          sUrl
        }
      }
      sCountryFull
      sCountry
      oImg {
        sUrl
      }
    }
  }
`
const battingStats = `
            nMatches
            nInnings
            nNotOut
            nBalls
            nCatches
            nHighest
            nRun100
            nRun4
            nRun50
            nRun6
            sStrike
            nRuns
            sAverage
`

const bowlingStats = `
            nBalls
            nHattrick
            nInnings
            nMatches
            nOvers
            nRuns
            nWicket4i
            nWicket5i
            sAverage
            nWickets
            nWicket10m
            sBestinning
            sBestmatch
            sEcon
            sStrike
            nExpensiveOverRuns
`

export const COMPARE_PLAYERS = gql`
query ComparePlayers($input: comparePlayersInput) {
  comparePlayers(input: $input) {
    stats {
      _id
      sFullName
      sCountry
      oImg {
        sUrl
      }
      sCountryFull
      sBowlingStyle
      sBirthPlace
      sBattingStyle
      dBirthDate
      oTeam {
        oImg {
          sUrl
        }
      }
      oPlayerStats {
        oBatting{
        firstclass {
          ${battingStats}
        }
        lista {
          ${battingStats}
        }
        t20 {
          ${battingStats}
        }
        test {
          ${battingStats}
        }
        odi {
          ${battingStats}
        }
        t20i {
          ${battingStats}
        }
       }
        oBowling{
         firstclass {
          ${bowlingStats}
        }
        lista {
          ${bowlingStats}
        }
        t20 {
          ${bowlingStats}
        }
        test {
          ${bowlingStats}
        }
        odi {
          ${bowlingStats}
        }
        t20i {
          ${bowlingStats}
        }
        }   
      }   
    }
  }
}
`
